import { useDispatch, useSelector } from 'react-redux';
import {
  closeLeaveSurveyModal,
  openLeaveSurveyModal,
  resetLeaveSurveyModal,
  disableLeaveSurveyModal,
} from 'actions/leave-survey-actions';
import { useCallback } from 'react';

const useLeaveSurveyModal = () => {
  const dispatch = useDispatch();
  const { open: surveyOpen, triggered: surveyTriggered, disableSurveyModal: surveyShowDisabled } = useSelector(
    ({ leaveSurveyReducer }) => leaveSurveyReducer
  );

  const disableSurvey = useCallback(() => dispatch(disableLeaveSurveyModal()), [dispatch]);
  const resetSurvey = useCallback(() => dispatch(resetLeaveSurveyModal()), [dispatch]);

  return {
    surveyOpen,
    surveyTriggered,
    surveyShowDisabled,
    openSurvey: (onClose = () => {}) => dispatch(openLeaveSurveyModal({ onClose })),
    closeSurvey: () => dispatch(closeLeaveSurveyModal()),
    resetSurvey,
    disableSurvey,
  };
};

export default useLeaveSurveyModal;
